import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/*
 * No params required.
 * Takes a formControlName and uses data for the value
 * Usage:
 *    import { customNotEmptySpaceValidator } from 'pf_styleguide';
 *
 * Example:
 *     this.form = this.fb.group({
 *          anything: ['', [customNotEmptyValidator()]]
 *     });
*/

function isEmptyInputValue(value: any): boolean {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

export function customNotEmptySpaceValidator(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        if (isEmptyInputValue(control.value)) {
            return null;  // don't validate empty values to allow optional controls
        }

        if (control.value.replace(/ +(?= )/g, '') === ' ') {
            return {notEmptySpace: true};
        }

        return null;
    };
}

